export default "__VITE_ASSET__BNzLXyYs__"